import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router';
import { useMain } from 'src/views/hooks/useMain';
import BillTemplateRenderer from './BillTemplateRenderer';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import PageContainer from 'src/components/container/PageContainer';
import { Button } from '@mui/material';

const BillGenerator = () => {
    const [data, setData] = useState({});
    const [clientData, setClientData] = useState({});
    const [loading, setLoading] = useState(true);
    const [feedbackUrl, setFeedbackUrl] = useState('');
    const [billUrl, setBillUrl] = useState('');
    const { billId } = useParams();
    const location = useLocation();
     const navigate = useNavigate();
    const { ownerId } = location.state || {};
    const { billType } = location.state || {}; 
    const componentRef = useRef();

    const {
        fetchBillById,
        fetchPackageBillById,
        setShowMessage,
        branchData,
        activeBranchId,
        fetchClientByNumber,
        getFeedbackUrl,
        getBillUrl,
    } = useMain();


    const selectedTemplate = branchData?.selectedBillTemplate !== undefined ? branchData.selectedBillTemplate : 1;
  const handleBackToAllBilling = () => {
     sessionStorage.setItem('preserveBillingFilters', 'true');
    navigate('/billings', { 
      state: { 
        fromDetails: true,
        previousPage: location.state?.previousPage || 1
      } 
    });
  };


    // const getData = async (billId) => {
    //     try {
    //         // First try to fetch as regular bill
    //         const regularBillRes = await fetchBillById(billId, `?branchId=${activeBranchId}`);

    //         if (regularBillRes.statusCode === 200) {
    //             setData({ ...regularBillRes.data });
    //             return;
    //         }

    //         // If not found as regular bill, try as package bill
    //         const packageBillRes = await fetchPackageBillById(billId, activeBranchId);
    //         if (packageBillRes.statusCode === 200) {
    //             setData({ ...packageBillRes.data });
    //             return;
    //         }

    //         setShowMessage({ message: 'Bill not found', messageType: 'error' });
    //     } catch (error) {
    //         console.error("Error fetching bill:", error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const getData = async (billId) => {
    try {
        // Case 1: If billType is 'package' or 'membership', directly fetch package bill
        if (billType === 'package' || billType === 'membership') {
            const packageBillRes = await fetchPackageBillById(billId, activeBranchId);
            if (packageBillRes.statusCode === 200) {
                setData({ ...packageBillRes.data });
            } else {
                setShowMessage({ message: 'Package bill not found', messageType: 'error' });
            }
        } else {
            // Case 2: Try regular bill first
            const regularBillRes = await fetchBillById(billId, `?branchId=${activeBranchId}`);
            if (regularBillRes.statusCode === 200) {
                setData({ ...regularBillRes.data });
            } else {
                // Fallback to package bill
                const packageBillRes = await fetchPackageBillById(billId, activeBranchId);
                if (packageBillRes.statusCode === 200) {
                    setData({ ...packageBillRes.data });
                } else {
                    setShowMessage({ message: 'Bill not found', messageType: 'error' });
                }
            }
        }
    } catch (error) {
        console.error("Error fetching bill:", error);
    } finally {
        setLoading(false);
    }
};


    console.log(data, 'dataBillsss')
    // Fetch client data
    const getClientData = async (clientNumber) => {
        try {
            const res = await fetchClientByNumber(clientNumber, activeBranchId);
            if (res.statusCode === 200) {
                setClientData(res.data);
            }
        } catch (error) {
            console.error("Error fetching client:", error);
        }
    };

    // Fetch feedback URL
    const getUrl = async () => {
        try {
            const res = await getFeedbackUrl(billId, `?branchId=${activeBranchId}`);
            if (res.statusCode === 200) {
                setFeedbackUrl(res.data || '');
            }
        } catch (error) {
            console.error("Error fetching feedback URL:", error);
        }
    };

    // Fetch bill URL
    const getBillPage = async () => {
        try {
            const res = await getBillUrl(billId);
            if (res.statusCode === 200) {
                setBillUrl(res.data || '');
            }
        } catch (error) {
            console.error("Error fetching bill URL:", error);
        }
    };

    // Calculate totals
    const calculateTotals = () => {
        const totalProducts = data?.products?.reduce((total, product) =>
            total + (product.price * product.quantity), 0) || 0;
        const totalServices = data?.services?.reduce((total, service) =>
            total + (service.price * service.quantity), 0) || 0;
        return totalProducts + totalServices;
    };

    // Format date
    const formatDate = (date) => {
        if (!date) return '';
        const [year, month, day] = date.split('-');
        return `${day}-${month}-${year}`;
    };

    // Format time
    const formatTime = (time) => {
        if (!time) return '';
        let [hours, minutes] = time.split(':').map(Number);
        const postfix = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${hours}:${minutes.toString().padStart(2, '0')} ${postfix}`;
    };

    useEffect(() => {
        if (billId && activeBranchId) {
            getData(billId);
            getUrl();
            getBillPage();
        }
    }, [billId, activeBranchId]);


    useEffect(() => {
        if (data?.clientNumber && activeBranchId) {
            getClientData(data.clientNumber);
        }
    }, [data?.clientNumber, activeBranchId]);

    // Prepare all data to pass to templates
    const billTemplateData = {
        ...data,
        branchData,
        clientData,
        feedbackUrl,
        billUrl,
        baseTotal: calculateTotals(),
        formattedDate: formatDate(data?.dateOfBilling),
        formattedTime: formatTime(data?.timeOfBilling),
        ownerId
    };

    return (
        <PageContainer title="Bill Invoice">
               <div style={{ marginBottom: '1rem' }}>
                <Button 
                    variant="outlined" 
                    color="primary" 
                    onClick={handleBackToAllBilling}
                >
                    Back to All Billings
                </Button>
            </div>
            {loading ? (
                <ShowLoader />
            ) : Object.keys(data).length === 0 ? (
                <div>No bill record found</div>
            ) : (
                <div ref={componentRef}>
                    <BillTemplateRenderer
                        selectedTemplate={selectedTemplate}
                        billData={billTemplateData}
                        branchData={branchData}
                        printRef={componentRef}
                    />
                </div>
            )}
        </PageContainer>
    );
};

export default BillGenerator;